import DecorativeStars from "@homeinstead/ui/components/animations/DecorativeStars";
import SpinningStar from "@homeinstead/ui/components/animations/SpinningStars";

export function ThankYouSuccessIcon() {
  return (
    <div className="relative mt-12">
      <SpinningStar />
      <DecorativeStars />
    </div>
  );
}
